"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_ELEVATION_REQUEST_ERROR_CODE = exports.ACCESS_ELEVATION_REQUEST_STRATUS = exports.ACCESS_ELEVATION_VALIDATE_ERROR_CODE = exports.ACCESS_ELEVATION_VALIDATE_STRATUS = exports.SYSTEM_MESSAGES_LOGIN2FA = void 0;
exports.SYSTEM_MESSAGES_LOGIN2FA = {
    OTP_ERROR_EMPTY_OTP: {
        type: 'ERROR',
        msgId: 'login-2fa-otp-error-empty-otp',
        defaultMsg: 'Please enter your One-time password.'
    },
    OTP_ERROR_INCORRECT_OTP: {
        type: 'ERROR',
        msgId: 'login-2fa-otp-error-incorrect-otp',
        defaultMsg: 'Please enter your One-time password.'
    }
};
exports.ACCESS_ELEVATION_VALIDATE_STRATUS = {
    ELEVATION_SUCCESS: 'SUCCESS',
    ELEVATION_FAILED: 'FAILED'
};
exports.ACCESS_ELEVATION_VALIDATE_ERROR_CODE = {
    WRONG_OTP: 'CAUTH-20058',
    EXCEED_MAXIMUM_RETRY: 'CAUTH-20012'
};
exports.ACCESS_ELEVATION_REQUEST_STRATUS = {
    ELEVATION_REQUEST_SUCCESS: 'SUCCESS',
    ELEVATION_REQUEST_FAILED: 'FAILED'
};
exports.ACCESS_ELEVATION_REQUEST_ERROR_CODE = {
    TOKENVALIDATION: 'CAUTH-20023'
};
